// frontend/modules/template/views/ContextScriptListView.tsx
import React, { useState } from 'react';
import { 
    Typography, 
    Button, 
    Card, 
    Form, 
    Select, 
    Input, 
    Space, 
    Divider 
} from 'antd';
import { PlusOutlined, SearchOutlined, ImportOutlined, ExportOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { ContextScriptList } from '../components/ContextScriptList';
import { ImportExportScripts } from '../components/ImportExportScripts';
import { useContextScripts } from '../hooks/useContextScripts';

const { Title } = Typography;

export const ContextScriptListView: React.FC = () => {
    const navigate = useNavigate();
    const [importExportVisible, setImportExportVisible] = useState(false);
    
    const { 
        filteredScripts, 
        isLoading, 
        filters, 
        setFilters, 
        clearFilters, 
        deleteScript 
    } = useContextScripts();
    
    const handleDelete = async (id?: string) => {
        if (!id) return;
        await deleteScript(id);
    };
    
    const handleSearch = (value: string) => {
        setFilters({ search: value });
    };
    
    return (
        <div>
            <div className="flex justify-between items-center mb-4">
                <Title level={2}>Context Scripts</Title>
                <Space>
                    <Button 
                        type="primary" 
                        icon={<PlusOutlined />}
                        onClick={() => navigate('/notifications/context-scripts/new')}
                    >
                        New Script
                    </Button>
                    <Button 
                        icon={<ImportOutlined />} 
                        onClick={() => {
                            setImportExportVisible(true);
                        }}
                    >
                        Import/Export
                    </Button>
                </Space>
            </div>
            
            <Card className="mb-4">
                <Form layout="inline" className="w-full">
                    <Form.Item label="Category" className="mb-2">
                        <Select
                            style={{ width: 140 }}
                            placeholder="All categories"
                            allowClear
                            value={filters.category}
                            onChange={(value) => setFilters({ category: value })}
                        >
                            <Select.Option value="LOAN">Loan</Select.Option>
                            <Select.Option value="SAVINGS">Savings</Select.Option>
                            <Select.Option value="ACCOUNT">Account</Select.Option>
                            <Select.Option value="SYSTEM">System</Select.Option>
                        </Select>
                    </Form.Item>
                    
                    <Form.Item label="Status" className="mb-2">
                        <Select
                            style={{ width: 140 }}
                            placeholder="All statuses"
                            allowClear
                            value={filters.active === undefined ? undefined : String(filters.active)}
                            onChange={(value) => setFilters({ 
                                active: value === undefined ? undefined : value === 'true' 
                            })}
                        >
                            <Select.Option value="true">Active</Select.Option>
                            <Select.Option value="false">Inactive</Select.Option>
                        </Select>
                    </Form.Item>
                    
                    <Form.Item className="mb-2 flex-grow">
                        <Input
                            placeholder="Search scripts"
                            prefix={<SearchOutlined />}
                            value={filters.search}
                            onChange={(e) => handleSearch(e.target.value)}
                            allowClear
                        />
                    </Form.Item>
                    
                    <Form.Item className="mb-2">
                        <Button onClick={() => clearFilters()}>
                            Clear Filters
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
            
            <Card>
                <ContextScriptList 
                    scripts={filteredScripts}
                    loading={isLoading}
                    onDelete={handleDelete}
                />
            </Card>
            
            <ImportExportScripts
                visible={importExportVisible}
                onClose={() => setImportExportVisible(false)}
            />
        </div>
    );
};
